const ITEMS = [
  "Infrastructure for a world in motion",
  "Moving goods",
  "Moving data",
  "Moving business",
];

export default function Marquee() {
  return (
    <section
      className="relative overflow-hidden border-y border-white/10 py-8 md:py-12"
      data-testid="marquee"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max items-baseline">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-baseline">
            {ITEMS.map((t, i) => (
              <span
                key={`${dup}-${t}`}
                className="flex items-baseline whitespace-nowrap"
              >
                <span
                  className={`font-display text-4xl font-black uppercase tracking-tight md:text-6xl ${
                    i % 2 === 1 ? "text-outline-faint" : "text-bone"
                  }`}
                >
                  {t}
                </span>
                <span className="mx-[3vw] font-mono text-xl text-amber md:text-2xl">—</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
